import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=67dda900&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=js&"
export * from "./Review.vue?vue&type=script&lang=js&"
import style0 from "./Review.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Review.vue?vue&type=style&index=1&id=67dda900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dda900",
  null
  
)

export default component.exports